import React from "react";
import { Flex, FlexProps } from "../flex";
import { BorderRadius, Color, ColorVariant } from "../../utils/theme";
import { useTheme } from "../theme";

interface StickerProps extends FlexProps {
  padded?: boolean;
  color?: Color;
  variant?: ColorVariant;
  radius?: BorderRadius;
}

export const Sticker = React.forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<StickerProps>
>(
  (
    {
      variant = "outline",
      color = "violet",
      padded = true,
      gap = "sm",
      radius,
      children,
      ...props
    },
    ref
  ) => {
    const theme = useTheme();

    return (
      <Flex
        data-radius={radius ?? theme?.radius ?? "lg"}
        style={{
          borderRadius: "max(var(--radius-lg), var(--radius-full))",
          padding: padded ? "var(--space-4)" : undefined,
        }}
        data-variant={variant}
        data-color={color}
        ref={ref}
        gap={gap}
        {...props}
      >
        {children}
      </Flex>
    );
  }
);

Sticker.displayName = "Sticker";
